module.exports = __webpack_public_path__ + "img/COMBO PALM GREEN.62c4870.svg";